import { SimpleShowLayout, Show, TextField, ReferenceField, BooleanField, Labeled } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import SecuredComponent from "server/security/SecuredComponent";
import { tenants } from "utils/tenants";
import BackButtonToolbar from "features/BackButtonToolbar";
import { paymentRequests } from "api/paymentApi";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowStructuralUnits = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за структурна единица"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Направление">
              <ReferenceField
                source="directionId"
                reference={administrationRequests.getDirectionsSelect()}
              >
                <TextField
                  label="Направление"
                  source="name"
                />
              </ReferenceField>
            </Labeled>
          </Grid>
          {settings.tenant === tenants.MU && (
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Предлага специална група">
                <BooleanField source="hasSpecialGroup" />
              </Labeled>
            </Grid>
          )}

          <SecuredComponent tenancies={tenants.MU}>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Iban">
                <ReferenceField
                  source="defaultIbanId"
                  reference={paymentRequests.getIbansSelect()}
                >
                  <TextField
                    label="Iban"
                    source="name"
                  />
                </ReferenceField>
              </Labeled>
            </Grid>
          </SecuredComponent>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Брой скъсвания">
              <TextField source="maxDisciplineFailures" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowStructuralUnits;
